import React from "react";

const FlightTicketPassenger = (props) => {
  return (
    <div className="traveller-details-table-container">
      <table className="traveller-details-table" style={{ width: "100%" }}>
        <thead>
          <tr>
            {!props.isPerPassenger && <th>S.No</th>}
            <th>Name</th>
            {/* <th>Passenger</th> */}
            <th>Type</th>
            <th>Ticket Number</th>
            {/* <th>Date of Birth</th>
                        <th>Passport Details</th> */}
            <th>
              Baggage
              <br />
              Cabin|Checkin
            </th>
            <th>Seat</th>
            <th>
              Meal
              <br />
              Preferences
            </th>
          </tr>
        </thead>
        <tbody>
          {!props.isPerPassenger
            ? props.passengers &&
              props.passengers.map((paxData, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    {paxData.title} {paxData.firstName} {paxData.lastName}
                  </td>
                  <td>{paxData?.type}</td>
                  <td>
                    {props?.journeyType === "onward"
                      ? paxData.onward_EticketNo
                      : paxData.return_EticketNo}
                  </td>
                  {/* <td>
                                {paxData.dob}
                            </td> */}
                  {/* <td>
                                {paxData?.passportNo !== "" && "PP No. " + paxData.passportNo}<br />
                                {paxData?.passportExpiryDate !== "" && "Expiry " + paxData.passportExpiryDate}<br />
                                {paxData?.passportCountry !== "" && "Country " + paxData.passportCountry}
                            </td> */}
                  <td>
                    {props?.journeyType === "onward"
                      ? paxData?.onward_baggage_description !== ""
                        ? paxData.onward_baggage_description
                        : "__"
                      : paxData?.return_baggage_description !== ""
                      ? paxData.return_baggage_description
                      : "__"}
                  </td>
                  <td>
                    {props?.journeyType === "onward"
                      ? paxData.onward_seat_description
                      : paxData.return_seat_description}
                  </td>
                  <td>
                    {props?.journeyType === "onward"
                      ? paxData.onward_meal_description
                      : paxData.return_meal_description}
                  </td>
                </tr>
              ))
            : props.isPerPassenger && (
                <tr>
                  <td>
                    {props.passenger?.title} {props.passenger?.firstName}{" "}
                    {props.passenger?.lastName}
                  </td>
                  <td>{props.passenger?.type}</td>
                  <td>
                    {props?.journeyType === "onward"
                      ? props.passenger?.onward_EticketNo
                      : props.passenger?.return_EticketNo}
                  </td>
                  {/* <td>
                                {props.passenger?.dob}
                            </td>
                            <td>
                                {props.passenger?.passportNo !== "" && "PP No. " + props.passenger?.passportNo}<br />
                                {props.passenger?.passportExpiryDate !== "" && "Expiry " + props.passenger?.passportExpiryDate}<br />
                                {props.passenger?.passportCountry !== "" && "Country " + props.passenger?.passportCountry}
                            </td> */}
                  <td>
                    7KG |{" "}
                    {props?.journeyType === "onward"
                      ? props.passenger?.onward_baggage_description !== ""
                        ? props.passenger?.onward_baggage_description
                        : "__"
                      : props.passenger?.return_baggage_description !== ""
                      ? props.passenger?.return_baggage_description
                      : "__"}
                  </td>
                  <td>
                    {props?.journeyType === "onward"
                      ? props.passenger?.onward_seat_description
                      : props.passenger?.return_seat_description}
                  </td>
                  <td>
                    {props?.journeyType === "onward"
                      ? props.passenger?.onward_meal_description
                      : props.passenger?.return_meal_description}
                  </td>
                </tr>
              )}
          <tr>
            <td colSpan={7} className="pax-contact-col">
              Passenger Contact Number:{" "}
              {props.deliveryAddress?.customerMobileNumber} | Mail:{" "}
              {props?.emailId}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FlightTicketPassenger;
